import http, { handleHttpError, handleHttpResponse } from '../../services/http'
import { HTTPResponse } from '../../services/http/http.types.ts'
import { IUser } from '../Users/users.types.ts'

export interface ILoginResponse {
  auth: {
    accessToken: string
    expires: number // ts
  }
  user: IUser
}
const login = (dto: {
  login: string
  password: string
  rememberMe: boolean
}): Promise<HTTPResponse<ILoginResponse>> => {
  return http.post('/nsi/v1/auth/login', dto).then(handleHttpResponse).catch(handleHttpError)
}

const refreshToken = async (): Promise<HTTPResponse<ILoginResponse>> => {
  return http.post('/nsi/v1/auth/refresh').then(handleHttpResponse).catch(handleHttpError)
}

const logout = async (): Promise<HTTPResponse<{}>> => {
  return http.post('/nsi/v1/auth/logout').then(handleHttpResponse).catch(handleHttpError)
}

const authApi = { refreshToken, login, logout }
export default authApi
